import { useMemo } from 'react';
import { useMeetings } from './useMeetings';

/**
 *
 * @param {int} eventId Event ID
 * @param {int} meetingId Meeting ID
 * @returns meeting | null
 */
export function useMeeting(eventId, meetingId) {
    const meetings = useMeetings(eventId);
    return useMemo(() => meetings.find(m => m.id == meetingId), [meetings, meetingId]);
}
